import surveyNameFormFieldName from 'config/surveyNameFormFieldName';

export default {
  name: {
    formFieldName: surveyNameFormFieldName,
    errors: {
      Required: 'Survey name required',
      Pattern: 'Invalid survey name',
      Unique: 'Survey name already used',
      MaxLength: 'Maximum name length exceeded',
    },
  },
};
